import MainCss from '../../assets_c/scss/main.scss';
import PageContainer from '../../extendable/Page';
import {BasicContactForm} from "../../components/basicContactForm/basicContactForm";
import {ServiceContactForm} from "../../components/serviceContactForm/serviceContactForm";
import {WarrantyContactForm} from "../../components/warrantyContactForm/warrantyContactForm";
import {topBar} from "../../components/topBar/topBar";
import appJS from '../../assets_c/js/app';
import autocomplete from '../../components/autocomplete/autocomplete';
import FlashMsg from "../../components/UI/flashMsg/flashMsg";
import {reviewsForm} from "../../components/products/details/reviewsForm/reviewsForm";
import axios from 'axios';
import Sticky from 'sticky-js/dist/sticky.min';
import product from "../../components/products/product/product";
import cart from "../../components/cart/cart";
import boxAlert from "../../components/UI/boxAlert/boxAlert";
import cookiesBar from "../../components/core/cookiesBar/cookiesBar";
import Vilpe from '../../containers/vilpe/vilpe';
import Video from '../../components/video/video';
import '../../components/productVisualizations/productVisualizations';
import {BasicRevievForm} from "../../components/basicContactForm/basicReviewForm";

let app = appJS();
let reviews = new reviewsForm();

class Main extends PageContainer {
	constructor() {
		super();
	};
	
	stickyjs() {
		
		let windowWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
		let windowHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
		
		if (windowHeight >= 800) {
			let sticky = new Sticky('.sticky-js');
		}
	}
	
	selectToHref() {
		let elements = document.getElementsByClassName('sort-links');
		
		for (let element of elements) {
			element.addEventListener('change', function () {
				window.location.href = this.value;
			});
		}
	};
	
	zero() {
		let elements = document.getElementsByClassName('zero');
		
		for (let element of elements) {
			element.value = 1;
		}
	};
	
	homepagePopularProducts() {
		let popularContainer = $(".homepage .popular");
		let popularCarousel = popularContainer.find('.popular-carousel');
		let filters = popularContainer.find(".popular-header__prices .filter");
		let owl = app.initPopularCarousel();
		
		let onChangeFilter = (e) => {
			let filter = e.target;
			filters.removeClass("active");
			$(filter).addClass("active");
			// load new populars
			
			let fd = new FormData();
			fd.append('priceMin', $(filter).data('min'));
			fd.append('priceMax', $(filter).data('max'));
			
			axios.post('popular-products.html?ajax=1', fd, {
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			}).then(function (response) {
				let data = response.data.data;
				if (data.html && data.html.length) {
					owl.trigger('destroy.owl.carousel').removeClass('owl-carousel owl-loaded');
					/*popularCarousel.css({
						'overflow': 'hidden',
						'height': popularCarousel.height()
					});*/
					popularCarousel.html(data.html);
					/*popularCarousel.css({
						'height': 'auto'
					});*/
				} else {
					popularCarousel.html('');
				}
				app.initPopularCarousel();
				setTimeout(function () {
					// owl.trigger('refresh.owl.carousel');
				}, 50);
			});
			
		};
		
		filters.on("click", onChangeFilter);
		
	}
	
	reviewsShowMore() {
		let container = document.querySelector('.tab-reviews__more-items');
		
		if (container) {
			let trigger = container.querySelector('.tab-reviews__more-items__trigger');
			
			if (trigger) {
				trigger.addEventListener('click', e => {
					e.preventDefault();
					
					container.classList.toggle('JS__more-review-items-opened');
				});
			}
		}
	}
	
	error404() {
		let page404 = document.getElementById('error404');
		let seconds = 5;
		let value404 = $(page404).data('error');
		
		if (typeof page404 !== 'undefined' && value404 === 404) {
			// $("#dvCountDown").show();
			$(".error404--count-down").html(seconds);
			setInterval(function () {
				seconds--;
				$(".error404--count").html(seconds);
				if (seconds === 0) {
					$(".error404--count-down").hide();
					window.location = document.querySelector("body").dataset.root;
				}
			}, 1000);
		}
	}
	
	targetBlank() {
		let items = document.querySelectorAll('.js-target-blank, .js-target-blank a');
		items.forEach(item => {
			if ((item.tagName).toLowerCase() == 'a') {
				item.setAttribute('target', '_blank');
			}
		});
	}
	
	boot() {
		let flash = new FlashMsg;
		let contactForm = new BasicContactForm();
		let reviewForm = new BasicRevievForm();
		let serviceForm = new ServiceContactForm();
		let warrantyForm = new WarrantyContactForm();
		// let reviews = new reviewsForm();
		topBar();
		// map();
		// appJS();
		// cart();
		autocomplete();
		this.selectToHref();
		this.zero();
		this.homepagePopularProducts();
		this.stickyjs();
		this.error404();
		this.reviewsShowMore();
		this.targetBlank();
		flash.removeGlobalFlash();
		Video();
		document.querySelector('.vilpe') ?
			Vilpe() : null;
	}
}

const main = new Main();

main.boot();




// WEBPACK FOOTER //
// ../containers/main/main.js